import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import BookingPage from './pages/BookingPage';
import ConfirmationPage from './pages/ConfirmationPage';
import StatusPage from './pages/StatusPage';
import ErrorPage from './pages/ErrorPage';
import OAuthSuccessPage from './pages/OAuthSuccessPage';
import OAuthErrorPage from './pages/OAuthErrorPage';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/book/:token" element={<BookingPage />} />
        <Route path="/confirmation/:token" element={<ConfirmationPage />} />
        <Route path="/status/:token" element={<StatusPage />} />
        <Route path="/oauth-success" element={<OAuthSuccessPage />} />
        <Route path="/oauth-error" element={<OAuthErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
